import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense.ts";
import { PremiumFeature } from "@/components-legacy/premium-feature";
import { useViewerHasAtLeastAdminRights } from "@/lib/rights/use-viewer-has-right.ts";
import { cn } from "@/utils/cn.ts";
import { SettingsFormHeader } from "@babackapp/react-hook-forms-components/form-page";
import useTranslation from "@babackapp/translations/use-translation";
import { Card, CardContent } from "@babackapp/ui/components/card";
import {
  customErrorKeys,
  customMessagesKeys,
} from "./custom-message-settings-form.tsx";
import { CustomMessageItem } from "./custom-messages-settings-item.tsx";

export function CustomMessagesList() {
  const { data: shop } = useCurrentShopSuspense();
  const t = useTranslation();

  const hasAdminRight = useViewerHasAtLeastAdminRights();

  const disabled =
    !hasAdminRight || !shop.plan.customisation
      ? t("settings.shop.errors.notAdmin")
      : false;

  return (
    <Card>
      <CardContent className="py-8">
        <div className="flex flex-col gap-4 items-center justify-between">
          <SettingsFormHeader
            title={t("settings.customMessage.title")}
            description={t("settings.customMessage.subtitle")}
          />
          {disabled ? <PremiumFeature /> : null}
        </div>
        <div className={cn("flex flex-col mt-2 gap-2")}>
          <span className="text-sm font-semibold text-muted-foreground mt-8">
            {t(
              "settings.customerPortal.sections.customMessages.sections.errors.title",
            )}
          </span>
          {customErrorKeys.map((key) => (
            <CustomMessageItem key={key} disabled={disabled} customKey={key} />
          ))}
          <span className="text-sm font-semibold text-muted-foreground mt-8">
            {t(
              "settings.customerPortal.sections.customMessages.sections.interface.title",
            )}
          </span>
          {customMessagesKeys
            .filter((key) => {
              if (key === "checkoutMessage") {
                return (
                  shop.exchange.reshippingHasToBePaid ||
                  shop.exchange.exchangeWithOtherArticles
                );
              }
              return true;
            })
            .map((key) => (
              <CustomMessageItem key={key} disabled={disabled} customKey={key} />
            ))}
        </div>
      </CardContent>
    </Card>
  );
}
